import Vue from "vue";
import VueRouter from "vue-router";

// 引入 Vuex store
// 引入页面组件
import Login from "@/pages/Login.vue";
import Order from "@/pages/Order.vue";
import Dashboard from "@/pages/Dashboard.vue";
import DealerManage from "@/pages/DealerManage.vue";
import ChatManage from "@/pages/ChatManage.vue";
import NoticeManage from "@/pages/NoticeManage.vue";
import PhoneReqManage from "@/pages/PhoneReqManage.vue";
import FavorManage from "@/pages/FavorManage.vue";
import AccountSettings from "@/pages/AccountSettings.vue";
import CosManage from "@/pages/CosManage.vue";
import PollManage from "@/pages/PollManage.vue";
import {utils} from "@/util/utils";
import {PUBLIC_PAGES} from "@/config";
import ProductAll from "@/pages/ProductAll.vue";
import AccessControl from "@/pages/AccessControl.vue";
import OtherSet from "@/components/sysSet/OtherSet.vue";
import UserManage from "@/pages/UserManage.vue";
import WechatUserManage from "@/pages/WechatUserManage.vue";
import EventOrderList from "@/components/eventorder/EventOrderList.vue";
import ProductEdit from "@/components/product/ProductEdit.vue";
import Log from "@/pages/Log.vue";
import MiuTeacher from "@/pages/MiuTeacher.vue";
import MiuTeacherService from "@/pages/MiuTeacherService.vue";
import MiuDomand from "@/pages/MiuDomand.vue";
import MiuTeacherServiceTagManage from "@/pages/MiuTeacherServiceTagManage.vue";
import MiuVipPlan from "@/pages/MiuVipPlan.vue";
import MiuVipOrder from "@/pages/MiuVipOrder.vue";
import MiuVipAuth from "@/pages/MiuVipAuth.vue";
import ComplaintManage from "@/pages/ComplaintManage.vue";
import SurveyQuestionnaire from "@/pages/SurveyQuestionnaire.vue";
import SurveyAnswer from "@/pages/SurveyAnswer.vue";
import EventTypeList from "@/pages/EventTypeList.vue";
import EventTypeEdit from "@/pages/EventTypeEdit.vue";

// 使用 VueRouter 插件
Vue.use(VueRouter);

const RouterView = {render: h => h('router-view')};

// 定义路由
const routes = [
    {
        path: '/product-admin',
        name: '商品管理',
        component: ProductAll,
        meta: {
            icon: 'el-icon-s-goods'
        },
    },
    {
        path: '/order',
        name: '商品订单',
        component: Order,
        meta: {
            icon: 'el-icon-s-order'
        },
    },
    {
        path: '/eventorder',
        name: '活动订单',
        component: EventOrderList,
        meta: {
            icon: 'el-icon-s-claim'
        },
    },
    {
        path: '/dealer',
        name: '执行团队管理',
        component: DealerManage,
        meta: {
            icon: 'el-icon-s-shop'
        },
    },
    {
        path: '/poll',
        name: '接龙管理',
        component: PollManage,
        meta: {
            icon: 'el-icon-chat-dot-round'
        },
    },
    {
        path: '/event-type',
        name: '订单流程模版',
        component: EventTypeList,
        meta: {
            icon: 'el-icon-s-operation'
        },
    },
    {
        path: '/user-manage',
        name: '用户管理',
        component: RouterView,
        meta: {
            icon: 'el-icon-user-solid'
        },
        children: [
            {
                path: 'staff',
                name: '内部用户',
                component: UserManage
            },
            {
                path: 'wechat',
                name: '微信用户',
                component: WechatUserManage
            }
        ],
    },
    {
        path: '/notice',
        name: '通知管理',
        component: NoticeManage,
        meta: {
            icon: 'el-icon-bell'
        },
    },
    {
        path: '/phone-req',
        name: '电话换号',
        component: PhoneReqManage,
        meta: {
            icon: 'el-icon-phone',
            hidden: true
        },
    },
    {
        path: '/favorites',
        name: '收藏管理',
        component: FavorManage,
        meta: {
            icon: 'el-icon-star-on',
            hidden: true
        },
    },
    {
        path: '/dashboard',
        name: '数据看板',
        component: Dashboard,
        meta: {
            icon: 'el-icon-s-data'
        },
    },
    {
        path: '/sys-set',
        name: '配置中心',
        component: RouterView,
        meta: {
            icon: 'el-icon-s-tools'
        },
        children: [
            {
                path: 'access-control',
                name: '权限控制',
                component: AccessControl
            },
            {
                path: 'other',
                name: '其它配置',
                component: OtherSet
            },
            {
                path: 'log',
                name: '系统日志',
                component: Log
            },
            {
                path: 'cos',
                name: 'COS存储',
                component: CosManage
            }
        ],
    },
    {
        path: '/miu',
        name: '家家育才',
        component: RouterView,
        meta: {
            icon: 'el-icon-s-custom'
        },
        children: [
            {
                path: 'miu-teacher',
                name: '教师审核',
                component: MiuTeacher
            },
            {
                path: 'miu-teacher-service',
                name: '教师服务',
                component: MiuTeacherService
            },
            {
                path: 'miu-domand',
                name: '需求审核',
                component: MiuDomand
            },
            {
                path: 'miu-teacher-service-tag-manage',
                name: '服务标签管理',
                component: MiuTeacherServiceTagManage,
                meta: {hidden: true}
            },
            {
                path: 'vip',
                name: 'VIP管理',
                component: RouterView,
                children: [
                    {
                        path: 'miu_vip_plan',
                        name: '购买方案管理',
                        component: MiuVipPlan
                    },
                    {
                        path: 'miu_vip_order',
                        name: '订单管理',
                        component: MiuVipOrder
                    },
                    {
                        path: 'other',
                        name: '用户VIP管理',
                        component: MiuVipAuth,
                    },
                ],
            },
            {
                path: 'miu-complaint',
                name: '投诉管理',
                component: ComplaintManage
            },
            {
                path: 'chat',
                name: '聊天管理',
                component: ChatManage
            },
            {
                path: 'survey',
                name: '问卷调查',
                component: RouterView,
                children: [
                    {
                        path: 'questionnaire',
                        name: '问卷管理',
                        component: SurveyQuestionnaire
                    },
                    {
                        path: 'answer',
                        name: '调查反馈',
                        component: SurveyAnswer
                    }
                ],
            },
        ],
    },
    // ---- 隐藏页面 ----
    {
        path: '/account/settings',
        name: '账号设置',
        component: AccountSettings,
        meta: {hidden: true}
    },
    {
        path: '/login',
        name: '用户登录',
        component: Login,
        meta: {hidden: true}
    },
    {
        path: '/product-edit',
        name: '商品编辑',
        component: ProductEdit,
        meta: {hidden: true}
    },
    {
        path: '/event-type/edit',
        name: '订单流程模版编辑',
        component: EventTypeEdit,
        meta: {hidden: true}
    }
];

// 创建并导出 VueRouter 实例
const router = new VueRouter({
    base: '/admin/',
    mode: "hash",
    routes,
});

// 添加全局前置守卫
router.beforeEach(async (to, from, next) => {
    // noinspection JSUnusedGlobalSymbols
    Vue.prototype.$lastRoute = from;

    const authRequired = !PUBLIC_PAGES.includes(to.path);

    // 判断用户登录状态
    const token = utils.cookie.getCookie("wms_token");

    // 设置页面标题
    const titleBase = '蜜蜂Wellorg';
    if (to.name) {
        document.title = to.name + "-" + titleBase;
    } else {
        // 如果路由没有指定标题，则可以设置一个默认标题
        document.title = titleBase;
    }

    let notToken = utils.string.vIsEmpty(token);

    if (authRequired && notToken) {
        // 如果需要登录验证且用户未登录，重定向到登录页面
        return next({
            path: '/login',
            replace: true
        });
    }

    return next();
});

export default router;
